// extracted by mini-css-extract-plugin
export default {"overlay":"Yv-z","bodyOpen":"Zv-z","content":"_v-z","header":"aw-z","close":"bw-z","closeNoHeading":"cw-z"};